import React, { useContext } from 'react'
import { Modal, NotificationManagerContext, Switch, Text, View } from 'oio-react'
import { Route, useHistory, useParams, useRouteMatch } from 'react-router-dom'
import uiConstants from 'config/constants/ui'
import InitiativeFileLibrary from 'src/apps/Files/components/InitiativeFileLibrary'
import FolderView from 'src/apps/Files/components/FolderView'
import { useInitiative, useUpdateInitiative } from 'src/graphql/hooks'

const ScheduleSessionEditFiles = () => {
   const history = useHistory()
   const { sessionSlug } = useParams()
   const match = useRouteMatch()
   const { showNotification } = useContext(NotificationManagerContext)

   const { initiative: session, networkStatus } = useInitiative({ slug: sessionSlug })
   const { updateInitiative } = useUpdateInitiative()

   // We don't want to display our "loading" state if the initiative
   // list is being refetched
   const initialLoading = networkStatus <= 2
   if (initialLoading) {
      return null
   }

   const handleToggleFiles = async () => {
      try {
         await updateInitiative({ id: session.id }, {
            appsFilesEnabled: !session.appsFilesEnabled
         })

         showNotification({
            message: 'Changes saved successfully',
            title: 'Success!',
            type: 'success'
         })
      } catch (err) {
         showNotification({
            message: err.message,
            title: 'Error!',
            type: 'error'
         })
      }
   }

   return (
      <View>
         <View
            borderRadius="6px"
            backgroundColor="#f5f5f5"
            display="flex"
            width="100%"
            padding="24px">
            <View flex="1 1 auto" paddingRight="60px">
               <Text size="2" weight="medium">
                  Files are
                  {session.appsFilesEnabled ? ' Enabled' : ' Not Enabled'}
               </Text>
               <Text size="1.5" color="#666">
                  {session.appsFilesEnabled
                     ? 'Files tab is currently visible for this schedule item. You can upload files and create folders.'
                     : 'Enable to upload files and show a files tab for this schedule item'
                  }
               </Text>
            </View>
            <View flex="0 0 auto">
               <Switch
                  checked={session.appsFilesEnabled}
                  onChange={handleToggleFiles}
                  highlightColor="#48c163"
               />
            </View>
         </View>
         {session.appsFilesEnabled && (
            <View>
               <InitiativeFileLibrary initiativeId={session.id} />
               <Route path={`${match.url}/folder/:containerId`}>
                  <Modal
                     backgroundColor="#fff"
                     width="100%[a-b] 90%[c] 980px[d-f]"
                     height="100%[a-b] 80%[c-f]"
                     borderRadius="6px"
                     onCloseTrigger={() => history.push(match.url)}
                     overlayBackgroundColor="rgba(80,80,80, 0.97)"
                     zIndex={uiConstants.zIndexes.tmpSettingsModal + 2}
                     open>
                     <FolderView
                        initiativeId={session.id}
                        onCloseButtonClick={() => history.push(match.url)}
                     />
                  </Modal>
               </Route>
            </View>
         )}
      </View>
   )
}

export default ScheduleSessionEditFiles
